import React, { useContext } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { InfoContext } from "../providers/InfosContextProvider";

const logo = process.env.PUBLIC_URL + "/assets/images/casas-do-nabao-logo.png";
const portugalFlag = process.env.PUBLIC_URL + "/assets/images/pt.png";
const enFlag = process.env.PUBLIC_URL + "/assets/images/en.png";

const Header = () => {
  const { texts, language, setLanguage } = useContext(InfoContext);
  const nextLanguage = language === "PT" ? "EN" : "PT";
  const nextFlag = nextLanguage === "PT" ? portugalFlag : enFlag;
  const nextLanguageLabel =
    nextLanguage === "PT" ? texts.header.pt : texts.header.en;

  return (
    <header className="header fixed-top">
      <Navbar expand="lg" className="d-flex align-items-center">
        <Container fluid>
          <Navbar.Brand href="/" className="d-flex align-items-center">
            <img className="logo-main" src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navmenu" />
          <Navbar.Collapse id="navmenu">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" className="nav-link">
                {texts.header.home}
              </Nav.Link>

              <Nav.Link as={Link} to="/properties" className="nav-link">
                {texts.header.buy}
              </Nav.Link>

              <Nav.Link as={Link} to="/sell" className="nav-link">
                {texts.header.sell}
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/properties?transaction=rent"
                className="nav-link"
              >
                {texts.header.rent}
              </Nav.Link>

              <Nav.Link as={Link} to="/contact" className="nav-link">
                {texts.header.contact}
              </Nav.Link>

              <Nav.Link as={Link} to="/about" className="nav-link">
                {texts.header.about}
              </Nav.Link>

              <Nav.Link as={Link} to="/news" className="nav-link">
                {texts.header.news}
              </Nav.Link>

              <button
                type="button"
                className="language-toggle"
                onClick={() => setLanguage(nextLanguage)}
                aria-label={nextLanguageLabel}
              >
                <img
                  src={nextFlag}
                  alt={nextLanguageLabel}
                  width="20"
                  height="20"
                />
              </button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
